<div class="gst-popup">
    <mat-icon (click)=" closeModal()" role="img" class="mat-icon notranslate material-icons mat-icon-no-color" style="font-size: 18px;" aria-hidden="true" data-mat-icon-type="font">clear</mat-icon>
    <h1>Add GST number</h1>
    <p>Use GTSIN for this booking(Optional)</p>

    <form class="example-form">
    
        <mat-form-field appearance="outline" >
          <mat-label>Company Name</mat-label>
          <input matInput placeholder="Company Name">
        </mat-form-field>

        <mat-form-field appearance="outline" >
          <mat-label>GST Number</mat-label>
          <input matInput placeholder="GST Number">
        </mat-form-field>
        
        <button mat-flat-button>Add</button>
      </form>
    </div>
